import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { InsuranceProviders } from '../enums/insurance-providers';
import { isParcelGuardActivated, isXCoverActivated } from '../services/insurance-service';

export const useDoFpsRequireWalletSetup = (fulfillmentPlanIds) => {
  const sellerProviderRequiresSetup = useSelector((state) => {
    const sellerLabelProviders = Global.selectSellerLabelProviders(state);
    const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, {
      fulfillmentPlanIds,
    });
    const uniqueSellerLabelProviderIds = new Set();
    fulfillmentPlans.forEach(
      ({ sellerLabelProviderId }) => sellerLabelProviderId && uniqueSellerLabelProviderIds.add(sellerLabelProviderId),
    );
    const sellerLabelProviderIds = Array.from(uniqueSellerLabelProviderIds);

    return sellerLabelProviders
      .filter((provider) => sellerLabelProviderIds.includes(provider.sellerLabelProviderId))
      .some((provider) => provider.requiresSetup);
  });

  const insuranceProviderRequiresSetup = useSelector((state) => {
    const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds });
    const isPurchasingParcelGuard = fulfillmentPlans.some(
      ({ insuranceProvider }) => insuranceProvider === InsuranceProviders.ParcelGuard.name,
    );
    const doesParcelGuardRequireSetup = isPurchasingParcelGuard && !isParcelGuardActivated(state);
    const isPurchasingXCover = fulfillmentPlans.some(({ insuranceProvider }) => insuranceProvider === InsuranceProviders.XCover.name);
    const doesXCoverRequireSetup = isPurchasingXCover && !isXCoverActivated(state);

    return doesParcelGuardRequireSetup || doesXCoverRequireSetup;
  });
  return sellerProviderRequiresSetup || insuranceProviderRequiresSetup;
};
